export default __webpack_public_path__ + "static/media/Favicon.4b426a59.png";